import { fixPathFromWindowsToLinux } from "./fixPathFromWindowsToLinux.ts";

/**
 * converts eg "Erica/Malcolm" to ["Erica","Malcolm"]
 * and "Erica/Malcolm/" to  ["Erica","Malcolm"]
 */
export function splitPath(path: string): string[] {
  // Windows compatibility
  const formattedPath = fixPathFromWindowsToLinux(path)?.trim() ?? "";

  if (formattedPath === "") {
    return [];
  }

  return formattedPath.split("/").filter((p) => p !== "");
}
